/**
 * Created by mitz.lad on 09/09/2016.
 */
define(['modules/form', 'modules/ajaxRequest', 'helpers/messages', 'json!data/response-messages.json', 'modules/ajaxListingsLoadMore'], function (form, ajaxRequest, messages, responseMessages, ajaxListingsLoadMore) {
    'user strict';

    // pull in global jquery instance that has all the plugins loaded
    var jQuery = $ = _jQuery;

    // open quick sign up form - trigger also bound to hide the normal login form
    var quickSignup = function () {
        $(document).ready(function () {
            // targeting id's instead of 'js-' prefix here as there are multiple instances of the login form
            var $quickAccessLogin = $('#login-quick-access'), // login wrapper containing all log in/sign up forms
                $quickSignupTrigger = $('#quick-signup-trigger', $quickAccessLogin), // trigger to show quick sign up form and hide normal login form
                $quickSignupPanel = $('#quick-signup', $quickAccessLogin), // quick sign up form
                $email = $('.js-quick-access-email', $quickAccessLogin); // normal login form email

            $quickSignupTrigger.on('click', function (event) {
                event.preventDefault();

                // time saver feature - get value of email from login form and copy to quick sign up form if not empty
                var emailVal = $('.js-quick-signup-email', $quickAccessLogin).val().replace(/ /g,'');

                if (emailVal.length > 0) {
                    $email.val(emailVal);
                }

                $quickSignupPanel.collapse('show');
            });
        });
    };

    // Redirects user to complete their profile and then redirects them to the details page, additional fields will need to be filled in on details page
    var completeSignupAndBook = function () {
        $(document).ready(function () {
            $(document).on('click', '.js-ride-signup-existing-not-completed', function (event) {
                $('.js-login-collapse-wrapper').hide();
                window.location.href = $(this).data('redirectTo');
            });
        });
    };

    // Gets additional sign up fields required to complete a ride booking if a user has not got an existing account
    var getAdditionalSignupFields = function () {
        $(document).ready(function () {
            $(document).on('click', '.js-ride-signup', function (event) {
                event.preventDefault();

                var $trigger = $(this);

                var $signupElements = $('#js-signup-elements'), // hidden div with signup form and additional fields
                    $quickSignupForm = $('#login-quick-access-quick-signup-signup-form'), // quick sign up form - targeting id instead of 'js-' prefix to as there multiple instance of the login form
                    $additionalFieldsWrapper = $('#js-additional-fields', $quickSignupForm), // wrapper to inject fields into
                    $additionalFields = $('.js-additional-sign-up-fields[data-product-id="' + $trigger.data('productId') + '"]'), // additional fields required for this ride's product
                    $currentAdditional = $('.js-current-additional', $additionalFieldsWrapper), // get any additional fields that are already in the quick sign up form
                    moveFields = $currentAdditional.data('productId') === $trigger.data('productId')  ? false : true;

                if (typeof $currentAdditional !== 'undefined' && moveFields) {
                    $('[name="redirect_to"]').val($trigger.data('redirectTo')).addClass('js-void-value-change');

                    // remove initial fields if user has already signed and has account
                    $('.js-remove-unrequired', $quickSignupForm).remove();

                    // remove any additional fields already in the form back to signup elements if its not the same set of fields that are additionally required
                    $('.js-current-additional', $additionalFieldsWrapper).removeClass('.js-current-additional').moveTo($signupElements);

                    // tag the additional field set with a class so it can be identified to be removed and move to the quick sign up form
                    $additionalFields.addClass('js-current-additional').moveTo($additionalFieldsWrapper);
                    $quickSignupForm.removeAttr('data-bound'); // remove data-bound attribute so form.validate() rebinds the validation for the amended form

                }
            });
        });
    };

    // displays additional fields for users who are logged in but have incomplete data for the particular ride
    var promptAdditionalFields = function () {
        'use strict';

        $(document).ready(function () {
            $(document).on('click', '.js-ride-signup-existing-completed', function (event) {
                event.preventDefault();

                var $trigger = $(this),
                    $additionalFields = $('.js-additional-sign-up-fields[data-product-id="' + $trigger.data('productId') + '"]'); // additional fields required for this ride's product

                // if there are fields that need to be requested move the fields, revalidated, set booking url as action and display else just redirect to the booking url
                if ($('input, textarea, select', $additionalFields).length > 0) {
                    var $signupElements = $('#js-signup-elements'), // hidden div with signup form and additional fields
                        $quickSignupForm = $('#signup-quick-access-signup-form'), // quick sign up form
                        $additionalFieldsWrapper = $('#js-additional-fields'), // wrapper to inject fields into
                        $currentAdditional = $('.js-current-additional', $additionalFieldsWrapper), // get any additional fields that are already in the quick sign up form
                        moveFields = $currentAdditional.data('productId') === $trigger.data('productId')  ? false : true;

                    if (typeof $currentAdditional !== 'undefined' && moveFields) {
                        $('[name="redirect_to"]').val($trigger.data('redirectTo')).addClass('js-void-value-change');

                        // remove any additional fields already in the form back to signup elements if its not the same set of fields that are additionally required
                        $('.js-current-additional', $additionalFieldsWrapper).removeClass('.js-current-additional').moveTo($signupElements);

                        // tag the additional field set with a class so it can be identified to be removed and move to the quick sign up form
                        $additionalFields.addClass('js-current-additional').moveTo($additionalFieldsWrapper);
                        $quickSignupForm.removeAttr('data-bound').attr('action', $trigger.data('redirectTo')); // remove data-bound attribute so form.validate() rebinds the validation for the amended form


                    }
                } else {
                    // navigate to booking link
                    $('.js-login-collapse-wrapper').hide();
                    window.location.href = $trigger.data('redirectTo');
                }
            });
        });
    };

    // set what action must be taken on the user's login status
    var signupAction = function () {
        'use strict';

        if ($('.js-ride-signup-existing-completed').length > 0) {
            promptAdditionalFields();
        }
        if ($('.js-ride-signup-existing-not-completed').length > 0) {
            completeSignupAndBook();
        }
        if ($('.js-ride-signup').length > 0) {
            getAdditionalSignupFields();
        }
    };

    // get back a list of the rides in a series the user may want to book on to
    // list is preselected for all dates but will return only the first 10 in the series
    // load more will load extra rides in the series
    var bookSeries = function () {
        $(document).ready(function () {
            var excludedRides = [];

            $(document).on('click', '.js-book-series-select', function (event) {
                event.preventDefault();

                var $this = $(this),
                    $listingWrapper = $('.js-ride-series-booking-initial-result'),
                    $formData = 'ride_id=' + $listingWrapper.data('rideId') + '&date_from=' + $listingWrapper.data('dateFrom') + '&date_to=' + $this.data('dateTo') + '&per_page=10&booking_initial_result=true&rides_series_booking_listing=true';

                var $response = ajaxRequest.request($listingWrapper.data('ajaxAction'), $listingWrapper.data('method'), $formData, $listingWrapper.data('messageWrapper'));

                $response
                    .done(function(response){
                        var $rideSeriesBookingForm = $('#js-ride-series-booking-form');

                        $listingWrapper.html('').append(response);
                        ajaxListingsLoadMore.bindLoadMore($($listingWrapper.data('pagination')));
                        $('[name="date_to"]', $rideSeriesBookingForm).val($this.data('dateTo')); // set date_to value in the submit series booking form
                        $rideSeriesBookingForm.removeClass('h-hide'); // reveal submit button for booking series
                        excludedRides = []; //clear the excluded list as we can't correlate which items were removed
                    })
                    .fail(function (){
                        messages.displayMessage({message: responseMessages['rides']['series-booking-load-fail'], messageWrapper: $listingWrapper.data('messageWrapper'), class: 'alert alert-danger'});
                    });
            });


            // listen for changes to the ride to add or remove id's from the excluded list
            $(document).on('change', '.js-series-booking-occurrence', function () {
                var $this =  $(this);
                if (!$this.is(':checked')) {
                    excludedRides.push($this.data('id')); // add value into array
                } else {
                    excludedRides.splice( $.inArray($this.data('id'), excludedRides), 1 ); // remove value from array
                }
            });

            // submit action for ride series booking
            $(document).on('submit', '#js-ride-series-booking-form', function (event){
                event.preventDefault();

                 var $form = $(this),
                     $formData = $form.serialize();

                // add any booked rides that are visible in the listings to the excluded list to enhance performance - any dates not visible (ie. not loaded in listings) will attempted to be booked by the the API
                $('.js-exclude-ride').each(function () {
                    excludedRides.push($(this).data('id'));
                });

                var $response = ajaxRequest.request($form.attr('action'), $form.attr('method'), $formData + '&exclude_rides=' + excludedRides, $form.data('messageWrapper'));

                $response
                    .done(function(data){
                        var $message, alertClass,
                            $formJSON = $form.serializeObject();


                        if (data.all_booked) {
                            alertClass = 'alert-success';
                            $message = $('<p/>').text('You\'re booked on all rides between ' + $formJSON.date_from + ' to ' + $formJSON.date_to + '.' );
                        } else {
                            var $p = $('<p/>'),
                                $ul = $('<ul/>');

                            $message = $('<div/>');
                            alertClass = 'alert-warning';

                            $p.text('We we\'re unable to book you onto the complete series, you have been booked onto the available dates, except for the the rides listed below.');

                            data.not_booked.forEach(function(ride) {
                                var $li = $('<li>');
                                $li.text(ride.title + ' - ' + ride.start_time);
                                $li.appendTo($ul);
                            });

                            $message.append($p, $ul);
                        }

                        messages.displayMessage({message: $message, messageWrapper: $form.data('messageWrapper'), class: 'alert ' + alertClass, messageType: 'custom'});
                        $($form.data('hideWrapper')).removeClass('in');
                    })
                    .fail(function (){
                        messages.displayMessage({message: responseMessages['rides']['series-booking-submit-fail'], messageWrapper: $form.data('messageWrapper'), class: 'alert alert-danger'});
                    });
            });
        });
    };

    return {
        quickSignup: quickSignup,
        signupAction: signupAction,
        bookSeries: bookSeries
    };
});
